import { render } from "./demo.vue?vue&type=template&id=1ec5dfc0&ts=true"
import script from "./demo.vue?vue&type=script&lang=ts"
export * from "./demo.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__